

export const mainPath = "https://notatkasb-backend.onrender.com";

